export default "__VITE_ASSET__DnSxhrsZ__"